import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "light" | "dark" | "system";

interface UiState {
  theme: Theme;
  setTheme: (t: Theme) => void;
  /** Last project opened per workspace slug, used by the workspace index redirect. */
  lastProject: Record<string, string>;
  rememberProject: (workspace: string, project: string) => void;
  /** Attention items the user dismissed or snoozed, keyed by id → expiry epoch ms. */
  snoozed: Record<string, number>;
  snooze: (id: string, ms: number) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme: "system",
      setTheme: (theme) => set({ theme }),
      lastProject: {},
      rememberProject: (workspace, project) =>
        set((s) => ({ lastProject: { ...s.lastProject, [workspace]: project } })),
      snoozed: {},
      snooze: (id, ms) => set((s) => ({ snoozed: { ...s.snoozed, [id]: Date.now() + ms } })),
    }),
    { name: "auradata.ui" },
  ),
);

export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
}
